// extracted by mini-css-extract-plugin
module.exports = {"ProseMirror":"ArticleHistoryContainer_ProseMirror__1fDf2","ArticleHistoryLoader":"ArticleHistoryContainer_ArticleHistoryLoader__2UKbV"};